<template lang="html">

    <!-- Sidebar -->
    <div class="border-right" id="sidebar-wrapper">
      <div class="header-sidebar" slot="header">
          <img :src="basepath+'/unodc_logo.png'" alt="" width="200" />
      </div>

      <div class="list-group list-group-flush">
        <router-link :to="{ path: '/dashboard/program-officer/form', query: { trainingId: trainingId}}" class="list-group-item list-group-item-action">Update Training </router-link>
        <router-link :to="{ path: '/dashboard/program-officer/AgendaForm', query: { trainingId: trainingId}}" class="list-group-item list-group-item-action">Add Agenda </router-link>
        <router-link :to="{ path: '/dashboard/program-officer/knowledgeBase', query: { trainingId: trainingId}}" class="list-group-item list-group-item-action">Add Knowledge Base  </router-link>
        <router-link :to="{ path: '/dashboard/program-officer/assessment', query: { trainingId: trainingId}}" class="list-group-item list-group-item-action">Assessment  </router-link>
               
        <router-link :to="{ path: '/dashboard/program-officer/createtrainerFeedback', query: { trainingId: trainingId}}" class="list-group-item list-group-item-action">Trainer's Feedback   </router-link>

        <router-link :to="{ path: '/dashboard/program-officer/createTraineesFeedback', query: { trainingId: trainingId}}" class="list-group-item list-group-item-action">Trainee's Feedback </router-link>
        <router-link :to="{ path: '/dashboard/program-officer/quickTrainerReg', query: { trainingId: trainingId}}" class="list-group-item list-group-item-action">Trainer Registration </router-link>
        <router-link :to="{ path: '/dashboard/program-officer/registration', query: { trainingId: trainingId}}" class="list-group-item list-group-item-action">Participant Registration </router-link>
        <router-link :to="{ path: '/dashboard/program-officer/trainees-approval', query: { trainingId: trainingId}}" class="list-group-item list-group-item-action">Trainees Approval </router-link>
        <router-link :to="{ path: '/dashboard/program-officer/trainee-material-approval', query: { trainingId: trainingId}}" class="list-group-item list-group-item-action">Trainee Materials Approval </router-link>
         
           <!-- <router-link to="/dashboard/program-officer/" class="list-group-item list-group-item-action">
            Participant Registration
          </router-link> -->
      </div>
    </div>
</template>

<script>
export default {
  data: () => ({
  
    active: true,
    trainingId : '',
    basepath :localStorage.getItem("BASE_PATH")
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingId =this.$route.query.trainingId;
  },
  created() {
    // bus.$on("sidebarStatus", data => {
    //   this.active = data;
    // });
  },
  methods: {
    // isSidebar() {
    //   bus.$emit("sidebarStatus", this.active);
    // }
  }
};
</script>
<style>
/* .list-group-item:hover {
  padding-left: 30px;
  transition: 0.5s ease;
} */
</style>

<style scoped>
/*!
 * Start Bootstrap - Simple Sidebar (https://startbootstrap.com/template-overviews/simple-sidebar)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-simple-sidebar/blob/master/LICENSE)
 */
.vs-collapse {
  padding: 0px !important;
}
.vs-collapse-item--header {
  padding: 0px !important;
}
@media (min-width: 768px) {
  .sidebarx {
    display: block !important;
  }
  .vs-sidebar--background {
    z-index: 0 !important;
    background: transparent !important;
  }
}

@media (max-width: 768px) {
  .vs-sidebar--background {
    background: rgba(0, 0, 0, 0.2) !important;
  }
}

body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */
</style>